import { render, staticRenderFns } from "./banco.vue?vue&type=template&id=6e5e1ce5&"
import script from "./banco.vue?vue&type=script&lang=js&"
export * from "./banco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports